// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';
//import appConfig from "../../config/appConfig";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// HOOKS
import { useGetAgentsByAgency } from "../../hooks/useGetAgents";
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import AgentsSection from "./AgentsSection";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
//import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
//import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";

interface AboutUsProps {
    agencyId: number;
    showAgents: boolean;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId, showAgents }) => {
    const { t } = useTranslation();
    //const partners = appConfig.content.partners;
    const { agents, loading: agentsLoading, error: agentsError } = useGetAgentsByAgency(agencyId);
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;
    if (agentsLoading && showAgents) return <LoadingIndicator />;
    if (agentsError && showAgents) console.error("Error fetching agents:", agentsError);

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Lato:wght@300;400&display=swap" rel="stylesheet" />
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.subHeaderTitle')} isSeo={true} />

            <main id="about-us-page" className="space-ptb position-relative">
                <div className="container-fluid w-special">
                    <p className="sub-title">{t('aboutUsPage.subTitle')}</p>
                    <h2 className="mb-5" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.title') as string }} />
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-8 mb-4">
                            <h3 className="mb-1">{t('aboutUsPage.subTitle1')}</h3>
                            <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }}></p>
                            <h3 className="mb-1">{t('aboutUsPage.subTitle2')}</h3>
                            <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }}></p>
                            <h3 className="mb-1">{t('aboutUsPage.subTitle3')}</h3>
                            <p className="mb-1" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }}></p>
                            <ol className="mb-0">
                                <li className="mb-2" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.list1Item1') as string }}></li>
                                <li dangerouslySetInnerHTML={{ __html: t('aboutUsPage.list1Item2') as string }}></li>
                            </ol>
                        </div>
                        <div className="col-12 col-lg-4">
                            <div className="text-center mb-5 mb-lg-0">
                                <img className="img-fluid my-img" src="/assets/images/altrePag/chi-siamo.webp" alt={t('aboutUsPage.imageAlt') as string} />
                            </div>
                        </div>
                        <div className="col-12">
                            <h3 className="mb-1" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.subTitle4') as string }}></h3>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }}></p>
                            <p className="mb-1" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }}></p>
                            <ol className="mb-4">
                                <li className="mb-2" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.list2Item1') as string }}></li>
                                <li className="mb-2" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.list2Item2') as string }}></li>
                                <li dangerouslySetInnerHTML={{ __html: t('aboutUsPage.list2Item3') as string }}></li>
                            </ol>
                            <h3 className="mb-1" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.subTitle5') as string }}></h3>
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para6') as string }}></p>
                            <a href="https://web.whatsapp.com/send?phone=393515166331" target="_blank" rel="noopener noreferrer" title={t('aboutUsPage.btnTitle') as string} className="btn">
                                <FontAwesomeIcon icon={faWhatsapp} className="mr-2"/>
                                {t('aboutUsPage.btnText') as string}
                            </a>
                        </div>
                    </div>
                    <AgentsSection
                        showAgents={showAgents}
                        agents={agents}
                        agentsLoading={agentsLoading}
                        agentsError={agentsError}
                    />
                </div>
            </main>
        </>
    );
};
export default AboutUs;